import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { useSEO } from '@/hooks/useSEO';

export default function Contact() {
  useSEO(
    'Contact Us | Earning Calculators.Com',
    'Get in touch with the Earning Calculators.Com team. We welcome your feedback, questions, and suggestions.'
  );

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-xl mx-auto">
        <h1 className="font-headline text-4xl md:text-5xl font-bold tracking-tighter mb-6 text-center">
          Contact Us
        </h1>
        <p className="text-center text-lg text-muted-foreground mb-12">
          Have a question, a suggestion for a new calculator, or just want to say hello? We'd love to hear from you.
        </p>
        <form className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="firstName">First Name</Label>
              <Input id="firstName" placeholder="First Name" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="lastName">Last Name</Label>
              <Input id="lastName" placeholder="Last Name" />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email Address</Label>
            <Input id="email" type="email" placeholder="your@email.com" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="subject">Subject</Label>
            <Input id="subject" placeholder="Calculator Suggestion" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" placeholder="I have an idea for a new tool..." rows={6} />
          </div>
          <div className="text-center">
            <Button type="submit" size="lg" className="w-full md:w-auto">
              Send Message
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}